function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
export default class ModifierList extends CatalogObjectSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      modifiers: {
        embedded: 'always',
        serializedOnFragment: 'modifier_list_data'
      }
    });
  }
  normalize(type, modifierList) {
    if (modifierList.modifier_list_data) {
      // Transform id -> channelId for channel integrations
      if (modifierList.modifier_list_data.channel_integrations) {
        modifierList.modifier_list_data.channel_integrations = modifierList.modifier_list_data.channel_integrations.map(integration => ({
          ...integration,
          channel_id: integration.id
        }));
      }
    }
    return super.normalize(type, modifierList);
  }
  serialize(snapshot, options) {
    const json = super.serialize(snapshot, options);

    // Transform channelId -> id for channel integrations
    if (json.modifier_list_data?.channel_integrations) {
      json.modifier_list_data.channel_integrations = json.modifier_list_data.channel_integrations.map(integration => {
        return {
          state: integration.state,
          id: integration.channel_id
        };
      });
    }
    return json;
  }
}